import { render, staticRenderFns } from "./ImsProfitLossTraders.vue?vue&type=template&id=39ce473a&"
import script from "./ImsProfitLossTraders.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossTraders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports